import { cva, type VariantProps } from "class-variance-authority"
import React from "react"

import { cn } from "@/lib/utils"

const alertVariants = cva("border text-center ", {
  variants: {
    variant: {
      default: "",
      error: "border-textPink text-textPink",
    },
    size: {
      default: "p-8 text-lg",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
})

export interface AlertProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof alertVariants> {}

export const Alert = React.forwardRef<HTMLButtonElement, AlertProps>(
  ({ className, variant, size, ...props }) => {
    return (
      <div
        className={cn(alertVariants({ variant, size, className }))}
        {...props}
      />
    )
  },
)
